<app-banner-interno [title]="'Página'" [titleBold]="'não encontrada'" [backgroundImage]="'assets/banner.png'">
</app-banner-interno>

<section class="not-found">
    <div class="container">
        <h2>Infelizmente não foi possível encontrar a página que você estava procurando,<br />volte ao início clicando
            <a routerLink="/inicio" title="aqui">aqui</a>.</h2>
    </div>
</section>